import styles from "./toolbox-components.module.css";
import { filterClasses } from "PosterEditor/utils/filter-classes";
import { useRef, useEffect } from "react";

interface ToolboxComponentInputProps {
  text: string;
  onChangeText: (text: string) => void;
  className?: string;
  autoFocusOnMount?: boolean;
  variant?: "outlined" | "minimal";
  disabled?: boolean;
}

export const ToolboxComponentInput = ({
  text,
  onChangeText,
  className,
  autoFocusOnMount,
  variant = "outlined",
  disabled = false,
}: ToolboxComponentInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocusOnMount && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocusOnMount]);

  return (
    <input
      ref={inputRef}
      className={filterClasses(
        styles.input,
        className,
        variant === "outlined" ? styles.inputOutlined : styles.inputMinimal
      )}
      placeholder="Place name"
      type="text"
      value={text}
      onChange={(e) => onChangeText(e.target.value)}
      disabled={disabled}
    />
  );
};
